export default function CPQMappingError(props = {}) {
  const { message, status, errors } = props;
  this.message = message;
  this.status = status;
  this.errors = errors;
}
